module.exports = __webpack_public_path__ + "img/charme_dark_grey_ba_list.b0c3dd12.jpg";